import { axios, APIBASE_REVIVERAPPLICATION } from "./ApiConfig";
import { PropertiesWithConfig, SalesItemTranslated } from "@/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

const getDynamicPropertiesForProduct = async (salesItemId: number, languageId: number) =>
  axios.get<PropertiesWithConfig[]>(`${APIBASE_REVIVERAPPLICATION}api/orders/${salesItemId}/propertiesWithConfig`, {
    params: {
      languageId,
    },
  });

export const useGetDynamicPropertiesForProduct = (
  salesItemId: number,
  languageId: number,
  options?: Partial<UseQueryOptions<PropertiesWithConfig[]>>
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<PropertiesWithConfig[]>({
    queryKey: ["getDynamicPropertiesForProduct", salesItemId, languageId],
    queryFn: async () => {
      const result = await getDynamicPropertiesForProduct(salesItemId, languageId);
      return result.data;
    },
    ...queryOptions,
  });
};

const getAllSalesItemsByLanguageId = async (languageId: number) =>
  axios.get<SalesItemTranslated[]>(`${APIBASE_REVIVERAPPLICATION}api/orders/salesitem/all/translated`, {
    params: {
      languageId,
    },
  });

export const useGetAllSalesItemsByLanguageId = (
  languageId: number,
  options?: Partial<UseQueryOptions<SalesItemTranslated[]>>
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<SalesItemTranslated[]>({
    queryKey: ["getAllSalesItemsByLanguageId", languageId],
    queryFn: async () => {
      const result = await getAllSalesItemsByLanguageId(languageId);
      return result.data;
    },
    ...queryOptions,
  });
};
